import React     from 'react';
import PropTypes from 'prop-types';
import Button    from '@material-ui/core/Button';

function Component (props) {
	const { text, size, onClick, color, variant } = props;
	const styles = {
		button : { ...commonStyle.button, ...sizeStyle[size].button, ...variantStyle[color][variant].button },
		text   : { ...commonStyle.text, ...sizeStyle[size].text, ...variantStyle[color][variant].text }
	};

	return (
		<Button style={styles.button} onClick={onClick || null}>
			<span style={styles.text}>{ text }</span>
		</Button>
		);
}

export default Component;

Component.defaultProps = {
	size    : 'medium',
	color   : 'primary',
	variant : 'contained'
};

Component.propTypes = {
	size      : PropTypes.string,
	color     : PropTypes.string,
	variant   : PropTypes.string,
	onClick   : PropTypes.func.isRequired
};

const commonStyle = {
	button : {
		textTransform   : 'none',
		lineHeight      : 'inherit',
		width           : '100%',
		borderRadius    : '40px',
		border          : 'solid 1px',
	},
	text: {
		fontFamily : 'Brandon Text Regular',
	}
};

const variantStyle = {
	primary : {
		contained : {
			button : {
				borderColor     : '#43a1b5',
				backgroundColor : '#43a1b5'
			},
			text : {
				color : '#ffffff'
			}
		},
		outlined : {
			button : {
				borderColor  : '#43a1b5',
			},
			text : {
				color : '#43a1b5'
			}
		}
	},
	secondary : {
		contained : {
			button : {
				borderColor     : '#d1a85f',
				backgroundColor : '#d1a85f'
			},
			text : {
				color : '#ffffff'
			}
		},
		outlined : {
			button : {
				borderColor : '#d1a85f'
			},
			text : {
				color : '#d1a85f'
			}
		}
	}
};

const sizeStyle = {
	small : {
		button : {
			height : '38px',
		},
		text : {
			fontSize : '18px'
		}
	},
	medium : {
		button : {
			height : '52px',
		},
		text : {
			fontSize : '20px'
		}
	},
	large : {
		button : {
			height : '71px',
		},
		text : {
			fontSize : '28px'
		}
	}
};
